import { Directive, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Directive({
  selector: '[appHideSearchFilter]',
})
export class HideSearchFilterDirective {
  @Input() isAdvancedFilterActive: boolean;
  @Output() isAdvancedFilterActiveChange = new EventEmitter<boolean>();

  constructor(private eRef: ElementRef) {}

  @HostListener('document:click', ['$event'])
  onFilterClickOut(event) {
    if (
      this.isAdvancedFilterActive &&
      !this.eRef.nativeElement.contains(event.target) &&
      event.target.id !== 'SearchSettings' &&
      event.target.id !== 'p-highlighted-option' &&
      !event.target.parentElement?.classList.contains('p-dropdown-item') &&
      !event.target.classList.contains('p-dropdown-clear-icon')
    ) {
      this.isAdvancedFilterActive = false;
      this.isAdvancedFilterActiveChange.emit(this.isAdvancedFilterActive);
    }
  }
}
